import React, { useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
import axios from "axios";

export const Unauthorized = () => {
  const navigate = useNavigate();

  const goBackToPreviousPage = () => {
    navigate("/crm/lead_dashboard");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md text-center">
        <ExclamationCircleIcon className="h-12 w-12 text-red-500 mx-auto" />
        <h1 className="text-3xl font-bold my-4">Unauthorized Access</h1>
        <p className="text-lg mb-6">
          You are not authorized to view this page.
        </p>
        <button
          onClick={goBackToPreviousPage}
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Go back
        </button>
      </div>
    </div>
  );
};

export const LoaderOne = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="bg-white p-4 rounded-md">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
        </div>
        <p className="text-center mt-4">Loading...</p>
      </div>
    </div>
  );
};

export const Pagination = ({
  links,
  currentPage,
  totalResults,
  onPageChange,
  from,
  to,
  lastPage,
}) => {
  const handlePageChange = (event, page) => {
    event.preventDefault();
    onPageChange(page);
  };

  const handlePrevClick = (event) => {
    const prevPage = currentPage > 1 ? currentPage - 1 : 1;
    handlePageChange(event, prevPage);
  };

  const handleNextClick = (event) => {
    const nextPage = currentPage < lastPage ? currentPage + 1 : lastPage;
    handlePageChange(event, nextPage);
  };

  return (
    <div className="bg-white px-4 py-3 sm:px-6">
      <div>
        <div className="flex flex-1 justify-between sm:hidden mb-3">
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{from}</span> to{" "}
            <span className="font-medium">{to}</span> of{" "}
            <span className="font-medium">{totalResults}</span> results
          </p>
        </div>
        {/* <div className="flex flex-1 justify-between sm:hidden">
                <a
                    href="#"
                    onClick={handlePrevClick}
                    className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                    Previous
                </a>
                <a
                    href="#"
                    onClick={handleNextClick}
                    className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                    Next
                </a>
            </div> */}
        <div className="flex flex-1 justify-between sm:hidden">
          <a
            href="#"
            onClick={handlePrevClick}
            className="relative inline-flex items-center rounded-md border border-gray-300 bg-white 
               px-6 py-3 text-base font-medium text-gray-700 hover:bg-gray-50"
          >
            Previous
          </a>
          <a
            href="#"
            onClick={handleNextClick}
            className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white 
               px-6 py-3 text-base font-medium text-gray-700 hover:bg-gray-50"
          >
            Next
          </a>
        </div>
      </div>

      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{from}</span> to{" "}
            <span className="font-medium">{to}</span> of{" "}
            <span className="font-medium">{totalResults}</span> results
          </p>
        </div>
        <div>
          <nav
            className="isolate inline-flex -space-x-px rounded-md shadow-sm"
            aria-label="Pagination"
          >
            <a
              href="#"
              onClick={handlePrevClick}
              className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
            </a>
            {links
              ?.filter(
                (link) => link.label !== "Previous" && link.label !== "Next"
              )
              .map((link, index) => (
                <a
                  key={index}
                  href="#"
                  onClick={(e) => handlePageChange(e, link.label)}
                  aria-current={link.active ? "page" : undefined}
                  className={`relative ${link.active
                      ? "z-10 bg-indigo-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0"
                    } inline-flex items-center px-4 py-2 text-sm font-semibold`}
                >
                  {link.label}
                </a>
              ))}
            <a
              href="#"
              onClick={handleNextClick}
              className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
            </a>
          </nav>
        </div>
      </div>
    </div>
  );
};

export const WhatsAppIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    viewBox="0 0 256 258"
  >
    <defs>
      <linearGradient
        id="logosWhatsappIcon0"
        x1="50%"
        x2="50%"
        y1="100%"
        y2="0%"
      >
        <stop offset="0%" stop-color="#1faf38" />
        <stop offset="100%" stop-color="#60d669" />
      </linearGradient>
      <linearGradient
        id="logosWhatsappIcon1"
        x1="50%"
        x2="50%"
        y1="100%"
        y2="0%"
      >
        <stop offset="0%" stop-color="#f9f9f9" />
        <stop offset="100%" stop-color="#fff" />
      </linearGradient>
    </defs>
    <path
      fill="url(#logosWhatsappIcon0)"
      d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"
    />
    <path
      fill="url(#logosWhatsappIcon1)"
      d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"
    />
    <path
      fill="#fff"
      d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"
    />
  </svg>
);

export const usePDFDownload = () => {

  const PDFDownload = async (endpoint, filename, data, setLoading) => {
    setLoading(true);
        const token = localStorage.getItem("token");
    try {
      const response = await axios({
        url: `public/api/${endpoint}/pdf`,
        method: "POST",
        data: data,
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("PDF downloaded successfully!");
    } catch (error) {
      toast.error("Failed to download PDF");
      console.error("Failed to download PDF", error);
    } finally {
      setLoading(false);
    }
  };

  return { PDFDownload };
};


// export const useExcelDownload = () => {
//   const ExcelDownload = async (endpoint, filename, data, setLoading) => {
//     setLoading(true);
//     const token = localStorage.getItem("token");
//     try {
//       const response = await axios({
//         url: `public/api/${endpoint}/export`,
//         method: "GET",
//         params: data,
//         responseType: "blob",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         }
//       });
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       toast.success("Excel downloaded successfully!");
//     } catch (error) {
//       toast.error("Failed to download Excel");
//       console.error("Failed to download Excel", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { ExcelDownload };
// };

export const useExcelDownload = () => {
  const excelDownload = async (endpoint, filename, data, setLoading) => {
    setLoading(true);
    try {
      const response = await axios({
        url: `public/api/${endpoint}/excel`,
        method: "POST",
        data: data,
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Excel downloaded successfully!");
    } catch (error) {
      toast.error("Failed to download Excel");
      console.error("Failed to download Excel", error);
    } finally {
      setLoading(false);
    }
  };

  return { excelDownload };
};